import type { ReactNode } from 'react';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
}

export function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
      {icon && (
        <div className="p-4 mb-4 bg-surface-800 rounded-full text-surface-500">
          {icon}
        </div>
      )}
      <h3 className="text-lg font-semibold text-surface-200">{title}</h3>
      {description && <p className="mt-1 text-sm text-surface-400 max-w-sm">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
